// extracted by mini-css-extract-plugin
export default {"Container":"Index_Container__QWk+y","Header":"Index_Header__GG2cm","Value":"Index_Value__CkcoS"};